import { e as createNode } from '../common/collector-ae3615f0.js';
export { C as Collector, F as Fragment, f as createFragment, e as createNode, g as createToken } from '../common/collector-ae3615f0.js';
import '../common/index-49c9a3af.js';

const h = createNode;

export { h };
